<template>
  <div id="user-project">
    <material-card
      color="general"
      title="Project Pending Task"
      text="Please check your pending task"
    >
      <v-data-table
        :headers="userProjectPendingTaskHeaders"
        :items="userProjectPendingTaskData"
        :total-items="totalRows"
        :expand="false"
        hide-actions
      >
        <template v-slot:items="props">
          <tr
            class="expandable"
            @click.stop=" (props.expanded = !props.expanded)">
            <td>{{ props.item.companyName }}</td>
            <td>{{ props.item.projectName }}</td>
            <td>{{ props.item.projectRef }}</td>
          </tr>
        </template>
        <template v-slot:expand="props">
          <v-flex mx-3>
            <v-data-table
              id="pendingtaskdetail"
              :headers="headerTaskDetail"
              :items="props.item.taskList || []"
              hide-actions
              dense
            >
              <template v-slot:items="props2">
                <tr>
                  <td>{{ props2.item.desc }}</td>
                  <td>{{ toStringDateOnly(props2.item.startDate) }}</td>
                  <td>{{ toStringDateOnly(props2.item.endDate) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </template>
      </v-data-table>
    </material-card>
  </div>
</template>
<script>
  import displayFormatterMixins from './../../../mixins/displayFormatterMixins'

  export default {
    name: 'UserProject',
    mixins: [displayFormatterMixins],
    data: () => ({
      userProjectPendingTaskData: [],
      userProjectPendingTaskHeaders: [
        { sortable: true, text: 'Company', value: 'companyName' },
        { sortable: true, text: 'Project Name', value: 'projectName' },
        { sortable: true, text: 'Project Ref', value: 'projectRef' }
        // { sortable: true, text: 'Pending Task', value: 'desc' },
        // { sortable: true, text: 'Due Date', value: 'endDate' },
      ],
      headerTaskDetail: [
        { sortable: true, text: 'Pending Task', value: 'desc' },
        { sortable: true, text: 'Start Date', value: 'startDate' },
        { sortable: true, text: 'Due Date', value: 'endDate' }
      ],
      username: localStorage.getItem('username'),
      totalRows: 0
    }),
    created () {
      this.getPendingProjectTask()
    },
    methods: {
      async getPendingProjectTask () {
        try {
          let response = await this.$http.get(`/api/project/pendingtask?username=${this.username}`)
          console.log(response)
          console.log(response.data)
          this.userProjectPendingTaskData = response.data
          this.totalRows = response.data.length
        } catch (error) {
          console.log(error)
        }
      }
    }
  }

</script>
<style>
  #pendingtaskdetail thead tr {
    background-color: antiquewhite;
  }

  #pendingtaskdetail table.v-table thead tr th {
    font-size: 1.025em;
  }
</style>
